<template>
	<div class="details" id="details" ref="pdfContent" v-loading="onloading" :element-loading-text="loadtext"
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="main">
			<div class="downBtnparsty">
				<div class="downBtn boxsizing" @click="clickDown()">点击下载报告</div>
				<div class="downBtn boxsizing" @click="clickimgDown(1.2)">生成长图保存</div>
				<!-- <div class="downBtn boxsizing" @click="exportPDF()">点击下载报告</div> -->
			</div>
			<div class="evaluationReport" id="pdfContent" ref="imgcontent">
				<!-- 封面 -->
				<div class="pageZero htmlpdf">
					<div class="one">
						<img :src="configurat.logoimg"/>
						<div class="oneline"></div>
					</div>
					<img class="two" :src="configurat.titleimg"/>
					<div class="three">{{configurat.title}}</div>
					<img class="four" :src="configurat.img"/>
					<div class="five">【测评试卷：{{info.name}}】</div>
					<div class="linebox">
						<div class="line"></div>
						<div class="lines"></div>
					</div>
					<div class="sex">
						<div class="sex_left">
							<div class="item">
								<div>编号</div>：{{info.number}}
							</div>
							<div class="item">
								<div>测评日期</div>：{{info.createtime}}
							</div>
							<div class="item">
								<div>姓名</div>：{{info.username}}
							</div>
							<div class="item">
								<div>学校</div>：{{info.school}}
							</div>
						</div>
						<div class="sex_right" v-if="info.teacherwx">
							<div>&nbsp;学习规划师↑</div>
							<img :src="info.teacherwx" />
						</div>
					</div>
				</div>

				<!-- 第二页 -->
				<div class="page pageTwo htmlpdf">
					<div class="title_border">
						<div>测评概况</div>
					</div>
					<div class="title_two">诊断标签：夯实基础考高分</div>
					<div class="labelbox">
						<div class="label">
							<div>成绩分析</div>
							<div id="pageTwo_map_one" style="height:300px;"></div>
						</div>
						<div class="label">
							<div>题型得分率</div>
							<div id="pageTwo_map_two" style="height:300px;"></div>
						</div>
						<div class="label">
							<div>常模对比</div>
							<div id="pageTwo_map_three" style="height:300px;"></div>
						</div>
					</div>
					<div class="originalScore">
						<div class="num">原始得分: {{info.scorenum}}</div>
						<table>
							<thead>
								<tr>
									<td>题型</td>
									<td>分值</td>
									<td>得分</td>
									<td>试题数</td>
									<td>答对</td>
									<td>个人正确率</td>
									<td>群体正确率</td>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item,i) in info.typejson" :key="i+'q'">
									<td>{{item.name}}</td>
									<td>{{item.total}}</td>
									<td>{{item.score}}</td>
									<td>{{item.num}}</td>
									<td>{{item.correct}}</td>
									<td>{{item.correctprop}}%</td>
									<td>{{item.avgaccuracy}}%</td>
								</tr>
							</tbody>
						</table>
						<div class="tips">注：常模是一种供比较的标准量数，由标准化样本测试结果及试题难度预估算法计算而来</div>
					</div>
					
					<div class="right">
						<div class="right_tit">预测第一提分空间<div>{{info.scoreincrease}}</div>分</div>
						<div class="right_info">
							根据本次诊断分析结果，结合历年考点考法大数据，精准推荐快速有效提分的考点考法课程。通过学习相关课程后，如果掌握了对应的考点考法，具备了课标要求的关键能力，能够在考试中提升{{info.scoreincrease}}分！
						</div>
					</div>
					<div class="yuce">
						<div class="item itemonesty" v-if="info.advantage.length > 0">
							<div class="item_tit">优势</div>
							<div id="yuce_one" style="height:420px;"></div>
							<div class="item_info">个人正确率>平均正确率的知识板块</div>
						</div>
						<div class="item" v-if="info.weakarr.length > 0">
							<div class="item_tit">薄弱</div>
							<div id="yuce_two" style="height:420px;"></div>
							<div class="item_info" v-html="'个人正确率<平均正确率的知识板块'"></div>
						</div>
						<div class="item" v-if="info.raise.length > 0">
							<div class="item_tit">拔高</div>
							<div id="yuce_three" style="height:420px;"></div>
							<div class="item_info">难度是困难、较难的错题该部分需要拔高</div>
						</div>
						<div class="item" v-if="info.shortcomings.length > 0">
							<div class="item_tit">补短</div>
							<div id="yuce_four" style="height:420px;"></div>
							<div class="item_info">难度是容易、较易的错题该部分需要补短</div>
						</div>
					</div>
				</div>

				<!-- 第三页 -->
				<div class="page pageThree htmlpdf">
					<div class="title_border">
						<div>学情雷达-知识</div>
					</div>
					<div class="titles"><span style="color: #3EC6F6;">知识</span>得分率雷达图</div>
					<div id="pageThree_map_one" style="height:460px;"></div>
					<div class="infos">
						<span class="top">知识</span>
						（具有事实、概念或程序性质的有组织信息体，是教学中传授与传承的内容）：根据受测学生的分项知识点的达标情况可以分析出，学生学到了哪些知识点？薄弱的知识点是哪些？<span
							class="red">关注哪些知识没有得到正确积累。</span>
					</div>
					<table>
						<tr>
							<td rowspan="2"><span>维度</span></td>
							<td colspan="3">得分率(%)</td>
							<td rowspan="2"><span>特点</span></td>
						</tr>
						<tr>
							<td>本人</td>
							<td>群体</td>
							<td>差值</td>
						</tr>
						<tr v-for="(item,i) in info.knowledgeinfo" :key="i+'w'">
							<td>{{item.name}}</td>
							<td>{{item.correctprop}}</td>
							<td>{{item.scoringrate}}</td>
							<td>{{item.difference}}</td>
							<td>
								<span :class="item.feature_e=='长板'?'chang':'duan'"
									v-if="item.feature_e!=''">{{item.feature_e}}</span>
								<span v-if="item.feature_e&&item.feature_e!=''&&item.feature&&item.feature!=''">+</span>
								<span :class="item.feature=='优势'?'chang':'duan'"
									v-if="item.feature!=''">{{item.feature}}</span>
							</td>
						</tr>
					</table>
					<p>长短板：学生在知识、技能、能力各分项指标中得分率较高的为长板，得分率较低的为短板。</p>
					<p>优劣势：学生在知识、技能、能力各分项指标中得分率高于群体（常模）为优势，低于群体（常模）为劣势。</p>
				</div>

				<!-- 第四页 -->
				<div class="page pageThree htmlpdf">
					<div class="title_border">
						<div>学情雷达-技能</div>
					</div>
					<div class="titles"><span style="color: #29C097;">技能</span>得分率雷达图</div>
					<div id="pageFour_map_one" style="height:650px;"></div>
					<div class="infos">
						<span class="top">技能</span>
						（用身体、语言或智力操作信息或事物的熟练程度，是教育或教学应完成的目标，表现是学生练习与训后结果）：根据受测学生在方法层面的长短板、与平均水平相比的优劣势，可以分析出，学生能使用哪些方法来解题？能否做到熟练使用这些方法？<span
							class="red">关注哪些方法不够熟练掌握。</span>
					</div>
					<table>
						<tr>
							<td rowspan="2"><span>维度</span></td>
							<td colspan="3">得分率(%)</td>
							<td rowspan="2"><span>特点</span></td>
						</tr>
						<tr>
							<td>本人</td>
							<td>群体</td>
							<td>差值</td>
						</tr>
						<tr v-for="(item,i) in info.skillinfo" :key="i+'e'">
							<td>{{item.name}}</td>
							<td>{{item.correctprop}}</td>
							<td>{{item.scoringrate}}</td>
							<td>{{item.difference}}</td>
							<td>
								<span :class="item.feature_e=='长板'?'chang':'duan'"
									v-if="item.feature_e!=''">{{item.feature_e}}</span>
								<span v-if="item.feature_e&&item.feature_e!=''&&item.feature&&item.feature!=''">+</span>
								<span :class="item.feature=='优势'?'chang':'duan'"
									v-if="item.feature!=''">{{item.feature}}</span>
							</td>
						</tr>
					</table>
					<p>长短板：学生在知识、技能、能力各分项指标中得分率较高的为长板，得分率较低的为短板。</p>
					<p>优劣势：学生在知识、技能、能力各分项指标中得分率高于群体（常模）为优势，低于群体（常模）为劣势。</p>
				</div>

				<!-- 第五页 -->
				<div class="page pageThree htmlpdf">
					<div class="title_border">
						<div>学情雷达-能力</div>
					</div>
					<div class="titles"><span style="color: #FF0000;">能力</span>得分率雷达图</div>
					<div id="pageFive_map_one" style="height:650px;"></div>
					<div class="infos">
						<span class="top">能力</span>
						（执行当前可观察到的活动优秀程度，体现的是教育作用相同的情况下，学生之间存在的个体差异，想想擅长）：通过反映受测学生在学习习惯、风格、认知通道层面特征，解释受测学生为什么没学到和为什么不会的问题，从中发现规律，规避劣势，找到最有效的复习通路。
						<span class="red">关注优势及问题形成的原因。</span>
					</div>
					<table>
						<tr>
							<td rowspan="2"><span>维度</span></td>
							<td colspan="3">得分率(%)</td>
							<td rowspan="2"><span>特点</span></td>
						</tr>
						<tr>
							<td>本人</td>
							<td>群体</td>
							<td>差值</td>
						</tr>

						<tr v-for="(item,i) in info.capacityinfo" :key="i+'r'">
							<td>{{item.name}}</td>
							<td>{{item.correctprop}}</td>
							<td>{{item.scoringrate}}</td>
							<td>{{item.difference}}</td>
							<td>
								<span :class="item.feature_e=='长板'?'chang':'duan'"
									v-if="item.feature_e!=''">{{item.feature_e}}</span>
								<span v-if="item.feature_e&&item.feature_e!=''&&item.feature&&item.feature!=''">+</span>
								<span :class="item.feature=='优势'?'chang':'duan'"
									v-if="item.feature!=''">{{item.feature}}</span>
							</td>
						</tr>
					</table>
					<p>长短板：学生在知识、技能、能力各分项指标中得分率较高的为长板，得分率较低的为短板。</p>
					<p>优劣势：学生在知识、技能、能力各分项指标中得分率高于群体(常模)为优势，低于群体(常模)为劣势。</p>
				</div>

				<!-- 第6页 -->
				<div class="page pageSix htmlpdf">
					<div class="title_border">
						<div>试卷分析&学习策略</div>
					</div>
					<div id="pageSix_map_one" style="height:650px;"></div>
					<div class="infos">
						本测评共涉及有
						<template v-for="(item,i) in info.allknowledgeinfo">
							<span :key="i+'u'" v-if="i==0">{{item.name}}</span>
							<span :key="i+'u'" v-if="i>0">，{{item.name}}</span>
						</template>
						等相关知识。
						<template v-if="info.accuracy !== 100">建议优先学习下图显示的知识点，并按照学习指数“先长后短”的顺序进行提升!</template>
					</div>
					<template v-if="info.accuracy !== 100">
						<div id="pageSix_map_two" style="height:550px;"></div>
					</template>
				</div>
				<!-- 插入知识树页面 -->
				<div class="page pageSix pagenopadd htmlpdf">
					<img class="programmesty" v-for="(item,i) in knowledge[info.grade+info.subject_id]" :key="i+'ls'" :src="item" alt="">
				</div>

				<!-- 第7页 -->
				<div class="page pageSeven htmlpdf">
					<div class="xxjy">学习建议</div>
					<div class="pageSevenCon" :style="{'background': 'url('+configurat.backerimg+') no-repeat center center'}">
						<!-- <img class="logo" src="../../assets/imgs/icon/logo@2x.png" /> -->
						<img class="logo" :src="configurat.logoimg">
						<div class="title">考试1对1学习建议</div>
						<div class="con"><span>{{info.username}}</span>同学，你好！<br />
							很高兴你能顺利完成本次名称为<span>《{{info.name}}》</span>难度系数为<span>{{info.difficulty}}</span>的测试，AI多维诊断报告显示了你在本次诊断中的考点掌握情况，从雷达图可以看出本次测试的<span>{{info.total}}</span>道题目所涉及的考点你掌握了<span>{{info.accuracy}}%</span>。<br />
							根据本次AI诊断报告给出如下提分建议：<br />
							（1）预测第一提分空间为<span>{{info.scoreincrease}}</span>分，根据本次诊断分析结果，结合历年考点考法大数据，AI精准推荐了快速有效提分的考点考法课程。通过学习相关课程后，如果掌握了对应的考点考法，具备了课标要求的关键能力，可在考试中提升<span>{{info.scoreincrease}}</span>分！<br />
							（2）在知识学情雷达中超过黄色线（常模曲线）并且到达边界，被蓝色覆盖部分对应的知识点，本测卷涉及的知识模块有限，这个部分并未显示，助学教练可以为你再次发送更多测卷，帮你挖掘优势长板，优化备考策略，提高效率。<br />
							<template v-if="info.weakarr&&info.weakarr.length>0">
								（3）未被蓝色覆盖并在黄色线以内的部分，是你掌握比较薄弱的考点，也就是<template v-for="(item,i) in info.weakarr"><span
										v-if="item.type==2"
										:key="i+'t'">【{{item.name}}】</span></template>需要多花时间加强，这部分也是能够让你最快提分的知识点。<br />
							</template>
							<template v-if="info.raisetext&&info.raisetext.length>0">
								（{{info.weakarr&&info.weakarr.length>0?'4':'3'}}）蓝色区域超过黄色线但未到达雷达图边界的部分，对应的是你可以继续拔高的知识点，也就是<span
									v-for="(item,i) in info.raisetext"
									:key="i+'y'">【{{item}}】</span>，突破这些知识点，会让你的成绩更上一层楼!<br />
							</template>
							<template v-if="info.weakarr&&info.weakarr.length>0">
								（{{info.raisetext&&info.raisetext.length>0?'5':'4'}}）在第3条建议中涉及的知识点通过学习提升达到黄色线后，还可进一步提升，达到黄色线以外，直至边界，这是你最后需要攻克的知识点，彻底消灭自己的劣势短板。<br />
							</template>
							即时诊断反馈，了解自己的学情对提升成绩非常重要，也是被证明最高效的学习方式，还可以选择其他相关试卷，看看更多知识点、考点的掌握情况。祝你取得更好的成绩!加油!
						</div>
						<div class="bot">
							<img class="lefimg" src="../../assets/imgs/icon/jianyi.png" />
							<div class="bot_rig">
								<div>中高考金牌规划师：</div>
								<div class="name">
									<img :src="info.teacherimg" />
									<div>{{info.createtime}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 第8页 -->
				<div class="page pageEight htmlpdf">
					<div class="pageEightCon">
						<div class="title_border">
							<div>知识掌握情况一览表</div>
						</div>
						<table>
							<thead>
								<tr>
									<td>测评知识点</td>
									<td>知识难度</td>
									<td>掌握程度</td>
									<td>建议学习时长</td>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item,i) in info.master" :key="i+'u'">
									<td>{{item.name}}</td>
									<td>{{item.difficulty}}</td>
									<td>{{item.master}}</td>
									<td>{{item.learn}}h</td>
								</tr>
							</tbody>
						</table>

					</div>
				</div>

				<!-- 第9页 -->
				<div class="page pageNine htmlpdf">
					<div class="pageEightCon">
						<div class="title_border">
							<div>个性化AI智慧课程表<span>(标※为AI预测最易失分点)</span></div>
						</div>
						<p class="tips">根据智慧诊断A分析结果，所呈现的被测学生的薄弱点、失分点。对症下药，制定如下课程学习方案：</p>
						<div class="itembox twoTable">
							<div class="item">
								<table>
									<thead>
										<tr>
											<td>课程名称</td>
											<td>所属知识点</td>
											<td>时长</td>
											<td>课程类型</td>
											<td>课程难度</td>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(item,i) in info.course" :key="i+'i'">
											<td>
												{{item.name}}
												<span style="color: #FF0000;font-weight: bold;">※</span>
											</td>
											<td>{{item.knowledge}}</td>
											<td>{{item.hour}}</td>
											<td>{{item.classtype}}</td>
											<td>{{item.difficulty_text}}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>

				<!-- 第10页 -->
				<div class="page pageTen htmlpdf" :style="{'background-image': 'url('+configurat.backimg+')'}">
					<div class="pageEightCon">
						<div class="title_border">
							<div>举一反三题目练习</div>
						</div>
						<div class="itembox" v-for="(item,i) in info.asquestion" :key="i+'o'">
							<div class="quest_read" v-if="item.read" v-html="item.read"></div>
							<div class="topic" style="white-space: pre-wrap;">
								第{{i+1}}题（{{item.questiontype==1?(item.answerarr.length>1?'多选':'单选'):'判断'}}） <span
									v-if="item.knowledge" class="levelparsty">{{item.knowledge}}</span>：<span
									v-html="item.stem"></span></div>
							<div class="topic" style="white-space: pre-wrap;" v-if="item.sketch"><img
									style="max-width: 100%;" :src="item.sketch" /></div>

							<template v-if="item.questiontype == 1">
								<template v-for="(items,j) in item.option">
									<div class="item" v-if="items.answer&&items.answer!=''&&items.answer!=null"
										:key="j+'o'+i">
										<div class="option_num">{{items.option}}</div>
										<div class="option_con" v-html="items.answer"></div>
									</div>
								</template>
							</template>
							<template v-if="item.questiontype == 2">
								<div class="item" v-for="(items,j) in item.trueOrFalse" :key="j+'tc'+i">
									<div class="option_con">{{items}}</div>
								</div>
							</template>
						</div>
					</div>
				</div>

				<!-- 第11页 -->
				<!-- background-image: ; -->
				<div class="page pageEleven htmlpdf" :style="{'background-image': 'url('+configurat.footerimg+'), url('+configurat.backimg+')'}">
					<div class="pageEightCon">
						<div class="title_border">
							<div>举一反三题目练习答案</div>
						</div>
						<div class="itembox" v-for="(item,i) in info.asquestion" :key="i+'p'">
							<div class="titlesty">第{{i+1}}题：</div>
							<div class="topic">正确答案：<span v-html="item.answer"></span></div>
							<div class="topic" style="white-space: pre-wrap;">答案解析：<br /><span
									v-html="item.analysis"></span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts'
	import html2Canvas from "html2canvas"
	import jsPDF from "jspdf"
	import { htmlPdf } from "../../assets/public/htmlToPDF.js"
	export default {
		name: 'evaluationReport',
		data() {
			return {
				onloading: false, //页面加载中方法
				loadtext: '报告生成中，请稍后...', //提示语
				info: {
					//优势 薄弱 拔高 补短
					advantage: [],
					weakarr: [],
					raise: [],
					shortcomings: [],
				},
				configurat:{}, //配置对象信息
				knowledge:{}, //学习知识库
			}
		},
		mounted() {
			document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=device-width');
			// 页面加载方法
			this.initFun();
		},
		methods: {
			// 页面加载方法
			initFun() {
				var that = this;
				this.$api.POST(this.$face.index_reportData, {
					id: this.$route.query.id
				}, function(res) {
					that.info = res.data;
					if (that.$utile.locatFun('app_id')) {
						var app_id = localStorage.getItem('app_id');
						if(app_id==1){
							that.knowledge = that.$store.state.knowledge;
						}else{
							that.knowledge = that.$store.state.knowledge_type;
						}
						that.$api.POST(that.$face.app_set,{app_id: app_id}, function(resd) {
							that.configurat = resd.data;
							if(res.data.username!=''){
								document.title = res.data.username + "-" + res.data.name + "-" + res.data.createtime.replace(/-/g, '') + "-" +resd.data.name;
							}else{
								document.title = res.data.name + "-" + res.data.createtime.replace(/-/g, '') + "-" +resd.data.name;
							}
						});
					}
					that.$nextTick(function() { //主要用于处理数据动态变化后,DOM还未及时更新的问题
						// 在 DOM 更新后，这里的 DOM 已经更新了
						if (that.info.advantage.length > 0) {
							that.getyuceOne(that.info.advantage);
							// that.getyuceOne(that.info.advantage, that.info.weakarr)
						}
						if (that.info.weakarr.length > 0) {
							that.getyuceTwo(that.info.weakarr)
							// that.getyuceTwo(that.info.advantage, that.info.weakarr)
						}
						if (that.info.raise.length > 0) {
							that.getyuceThree(that.info.raise)
						}
						if (that.info.shortcomings.length > 0) {
							that.getyuceFour(that.info.shortcomings)
						}
					});
					that.getpageTwoMapOne(that.info.accuracy)
					that.getpageTwoMapTwo(that.info.typejson)
					that.getpageTwoMapThree(that.info.normscore)
					that.getpageThreeMapOne(that.info.knowledgeinfo);
					that.getpageFourMapOne(that.info.skillinfo);
					that.getpageFiveMapOne(that.info.capacityinfo);
					that.getpageSixMapOne(that.info.allknowledgeinfo);
					that.getpageSixMapTwo(that.info.weaklearn);
				});
			},
			//调取打印
			clickDown() {
				var ua = navigator.userAgent.toLowerCase();
				if (ua.indexOf('micromessenger') !== -1) {
					this.$utile.prompt('warning','微信不支持下载，请复制链接去手机浏览器下载',function(){},1);
				} else {
					window.print();
					// 执行非微信浏览器的操作
				}
			},
			//优势雷达图
			getyuceOne(arr, arry) {
				var myChart = echarts.init(document.getElementById('yuce_one'))
				var list = [],
					mylist = [],
					alllist = [];
				arr.forEach((item, i) => {
					list.push({
						name: item.name
					});
					if (this.info.accuracy == 100) {
						mylist.push(1)
					} else if (this.info.accuracy == 0) {
						mylist.push(0)
					} else {
						mylist.push(item.num);
					}

					// alllist.push(arry[i].num);
				})
				let option = {
					color: ['#0070C2', '#FFBF00'],
					grid: {
						top: '0px',
						bottom: '0px',
						left: '0px',
						right: '0px',
					},
					radar: [{
						indicator: list,
						radius: '70%', //图表占满整个div
						size: '100%',
						center: ['50%', '50%'],
						axisName: {
							color: '#000',
							fontSize: 14, // 文字字号
							//指示器文字换行 start
							formatter: function(text){
								var strlength = text.length;
								if(strlength % 16 != 0){
									text = text.replace(/\S{16}/g,function(match){
										console.log(match);
										return match + '\n'
									})
								}else{
									text = text.replace(/\S{16}/g,function(match){
										console.log(match);
										return match + '\n'
									});
									strlength = text.length;
									text = text.substring(0,strlength - 1);
								}
								return text
							}
							//指示器文字换行 end
						},
					}],
					series: [{
						type: 'radar',
						emphasis: {
							lineStyle: {
								width: 2
							}
						},
						symbol: "none", // 去掉图表中各个图区域的边框线拐点
						itemStyle: {
							normal: {
								// color: "rgba(0,0,0,0)", // 图表中各个图区域的边框线拐点颜色
								// lineStyle: {
								// 	color: "white" // 图表中各个图区域的边框线颜色
								// },
								areaStyle: {
									type: 'default'
								}
							}
						},
						data: [{
								value: mylist,
								areaStyle: {
									color: '#0070C2',
								}
							},
							// {
							// 	value: alllist,
							// 	areaStyle: {
							// 		color: '#FFBF00',
							// 	}
							// }
						]
					}, ]
				};
				myChart.setOption(option);
			},
			//薄弱雷达图
			getyuceTwo(arr, arry) {
				var myChart = echarts.init(document.getElementById('yuce_two'))
				var list = [],
					mylist = [],
					alllist = [];
				arr.forEach((item, i) => {
					list.push({
						name: item.name
					});

					if (this.info.accuracy == 0) {
						mylist.push(1)
					} else if (this.info.accuracy == 100) {
						mylist.push(0)
					} else {
						mylist.push(item.num);
					}

					// alllist.push(arry[i].num);
				})
				let option = {
					color: ['#FFBF00', '#0070C2'],
					grid: {
						top: '0px',
						bottom: '0px',
						left: '0px',
						right: '0px',
					},
					radar: [{
						indicator: list,
						radius: '70%', //图表占满整个div
						size: '100%',
						center: ['50%', '50%'],
						axisName: {
							color: '#000',
							fontSize: 14, // 文字字号
							//指示器文字换行 start
							formatter: function(text){
								var strlength = text.length;
								if(strlength % 16 != 0){
									text = text.replace(/\S{16}/g,function(match){
										console.log(match);
										return match + '\n'
									})
								}else{
									text = text.replace(/\S{16}/g,function(match){
										console.log(match);
										return match + '\n'
									});
									strlength = text.length;
									text = text.substring(0,strlength - 1);
								}
								return text
							}
							//指示器文字换行 end
						},
					}],
					series: [{

						type: 'radar',
						emphasis: {
							lineStyle: {
								width: 2
							}
						},
						symbol: "none", // 去掉图表中各个图区域的边框线拐点
						itemStyle: {
							normal: {
								// color: "rgba(0,0,0,0)", // 图表中各个图区域的边框线拐点颜色
								// lineStyle: {
								// 	color: "white" // 图表中各个图区域的边框线颜色
								// },
								areaStyle: {
									type: 'default'
								}
							}
						},
						data: [{
								value: mylist,
								areaStyle: {
									color: '#FFBF00',
								}
							},
							// {
							// 	value: alllist,
							// 	areaStyle: {
							// 		color: '#0070C2',
							// 	}
							// }
						]
					}, ]
				};
				myChart.setOption(option);
			},
			//拔高雷达图
			getyuceThree(arr, arry, copy) {
				var myChart = echarts.init(document.getElementById('yuce_three'))
				var list = [],
					mylist = [],
					alllist = [];
				arr.forEach((item, i) => {
					list.push({
						name: item.name
					});
					// alllist.push(arry[i].num);

					if (this.info.accuracy == 0) {
						mylist.push(1)
					} else if (this.info.accuracy == 100) {
						mylist.push(0)
					} else {
						mylist.push(item.num);
					}
				})
				let option = {
					color: ['#FFBF00', '#0070C2'],
					grid: {
						top: '0px',
						bottom: '0px',
						left: '0px',
						right: '0px',
					},
					radar: [{
						indicator: list,
						radius: '70%', //图表占满整个div
						size: '100%',
						center: ['50%', '50%'],
						axisName: {
							color: '#000',
							fontSize: 14, // 文字字号
							//指示器文字换行 start
							formatter: function(text){
								var strlength = text.length;
								if(strlength % 16 != 0){
									text = text.replace(/\S{16}/g,function(match){
										console.log(match);
										return match + '\n'
									})
								}else{
									text = text.replace(/\S{16}/g,function(match){
										console.log(match);
										return match + '\n'
									});
									strlength = text.length;
									text = text.substring(0,strlength - 1);
								}
								return text
							}
							//指示器文字换行 end
						},
					}],
					series: [{
						type: 'radar',
						emphasis: {
							lineStyle: {
								width: 2
							}
						},
						symbol: "none", // 去掉图表中各个图区域的边框线拐点
						itemStyle: {
							normal: {
								// color: "rgba(0,0,0,0)", // 图表中各个图区域的边框线拐点颜色
								// lineStyle: {
								// 	color: "white" // 图表中各个图区域的边框线颜色
								// },
								areaStyle: {
									type: 'default'
								}
							}
						},
						data: [{
								value: mylist,
								areaStyle: {
									color: '#FFBF00',
								}
							},
							// {
							// 	value: alllist,
							// 	areaStyle: {
							// 		color: '#0070C2',
							// 	}
							// }
						]
					}, ]
				};
				myChart.setOption(option);
			},
			//补短雷达图
			getyuceFour(arr, arry, copy) {
				var myChart = echarts.init(document.getElementById('yuce_four'))
				var list = [],
					mylist = [],
					alllist = [];
				arr.forEach((item, i) => {
					list.push({
						name: item.name
					});

					if (this.info.accuracy == 0) {
						mylist.push(1)
					} else if (this.info.accuracy == 100) {
						mylist.push(0)
					} else {
						mylist.push(item.num);
					}

					// alllist.push(arry[i].num);
				})
				let option = {
					color: ['#FFBF00', '#0070C2'],
					grid: {
						top: '0px',
						bottom: '0px',
						left: '0px',
						right: '0px',
					},
					radar: [{
						indicator: list,
						radius: '70%', //图表占满整个div
						size: '100%',
						center: ['50%', '50%'],
						axisName: {
							color: '#000',
							fontSize: 14, // 文字字号
							//指示器文字换行 start
							formatter: function(text){
								var strlength = text.length;
								if(strlength % 16 != 0){
									text = text.replace(/\S{16}/g,function(match){
										console.log(match);
										return match + '\n'
									})
								}else{
									text = text.replace(/\S{16}/g,function(match){
										console.log(match);
										return match + '\n'
									});
									strlength = text.length;
									text = text.substring(0,strlength - 1);
								}
								return text
							}
							//指示器文字换行 end
						},
					}],
					series: [{

						type: 'radar',
						emphasis: {
							lineStyle: {
								width: 2
							}
						},
						symbol: "none", // 去掉图表中各个图区域的边框线拐点
						itemStyle: {
							normal: {
								// color: "rgba(0,0,0,0)", // 图表中各个图区域的边框线拐点颜色
								// lineStyle: {
								// 	color: "white" // 图表中各个图区域的边框线颜色
								// },
								areaStyle: {
									type: 'default'
								}
							}
						},
						data: [{
								value: mylist,
								areaStyle: {
									color: '#FFBF00',
								}
							},
							// {
							// 	value: alllist,
							// 	areaStyle: {
							// 		color: '#0070C2',
							// 	}
							// }
						]
					}, ]
				};
				myChart.setOption(option);
			},
			// 成绩分析-仪表盘
			getpageTwoMapOne(val) {
				var myChart = echarts.init(document.getElementById('pageTwo_map_one'))
				let option = {
					series: [{
						type: 'gauge',
						axisLine: {
							lineStyle: {
								width: 20,
								color: [
									[0.3, '#91C7AE'],
									[0.7, '#63869E'],
									[1, '#C23531']
								]
							}
						},
						pointer: {
							itemStyle: {
								color: 'auto'
							}
						},
						axisTick: {
							distance: -20,
							length: 8,
							lineStyle: {
								color: '#fff',
								width: 2
							}
						},
						splitLine: {
							distance: -10,
							length: 10,
							lineStyle: {
								color: '#fff',
								width: 3
							}
						},
						axisLabel: {
							color: 'inherit',
							distance: 25,
							fontSize: 16
						},
						detail: {
							valueAnimation: true,
							formatter: '{value}%',
							color: 'inherit',
							offsetCenter: [0, '80%'],
						},
						data: [{
							value: val
						}]
					}]
				};
				myChart.setOption(option);
			},
			// 成绩分析-柱状图（横向）
			getpageTwoMapTwo(arr) {
				var myChart = echarts.init(document.getElementById('pageTwo_map_two'))
				var list = [],
					mylist = [];
				arr.forEach((item) => {
					list.push(item.name);
					mylist.push(item.correctprop);
				})
				let option = {
					title: {
						text: ''
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					legend: {
						data: list
					},
					grid: {
						left: '0%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						show: true,
						type: 'value',
						boundaryGap: [0, 0.01],
					},
					yAxis: {
						show: true,
						type: 'category',
						data: list,

					},
					series: [{
						name: '',
						type: 'bar',
						data: mylist,
						barWidth: 30,
						itemStyle: {
							barBorderRadius: [0, 20, 20, 0],
							color: '#6EC775'
						},

					}]
				};
				myChart.setOption(option);
			},
			// 成绩分析-柱状图（纵向）
			getpageTwoMapThree(arr) {
				var myChart = echarts.init(document.getElementById('pageTwo_map_three'))
				let option = {
					title: {
						text: '',
					},
					tooltip: {
						trigger: 'axis',
					},
					legend: {},
					grid: {
						left: '20%',
					},
					toolbox: {
						show: true,
					},
					// calculable: true,
					xAxis: [{
						type: 'category',
						data: ['常模得分率', '我的得分率', ]
					}],
					yAxis: [{
						type: 'value',
						data: ['0', '10', '20', '30', '40', '50', '60', '70', '80', '90', '100'],
					}],
					series: [{
							name: '',
							type: 'bar',
							barWidth: '50%', // 设置宽度
							data: [{
									value: arr[0],
									itemStyle: {
										color: '#FFAF26'
									}
								},
								{
									value: arr[1],
									itemStyle: {
										color: '#0EC285'
									}
								},
							]
						}

					]
				};
				myChart.setOption(option);
			},
			// 学情雷达-技能
			getpageThreeMapOne(arr) {
				var myChart = echarts.init(document.getElementById('pageThree_map_one'))
				var list = [],
					mylist = [],
					alllist = [];
				arr.forEach((item, i) => {
					if (arr.length > i + 1) {
						list.push({
							name: item.name,
							max: 100
						});
						mylist.push(item.correctprop);
						alllist.push(item.scoringrate);
					}
				})
				let option = {
					color: ['#FCB01F', '#2299F5'],
					title: {
						text: ''
					},
					legend: {},
					radar: [{
						indicator: list,
						center: ['50%', '50%'],
						radius: 180,
						axisName: {
							color: '#000',
							// backgroundColor: '#666',
							// borderRadius: 3,
							// padding: [3, 5]
						}
					}],
					series: [{
						type: 'radar',
						emphasis: {
							lineStyle: {
								width: 4
							}
						},
						data: [{
								value: alllist,
								name: '全体得分率'
							},
							{
								value: mylist,
								name: '我的得分率',
								areaStyle: {
									color: 'rgba(34,153,245, 0.6)'
								}
							}
						]
					}]
				};
				myChart.setOption(option);
			},
			// 学情雷达-技能
			getpageFourMapOne(arr) {
				var myChart = echarts.init(document.getElementById('pageFour_map_one'))
				var list = [],
					mylist = [],
					alllist = [];
				arr.forEach((item, i) => {
					if (arr.length > i + 1) {
						list.push({
							name: item.name,
							max: 100
						});
						mylist.push(item.correctprop);
						alllist.push(item.scoringrate);
					}
				})
				let option = {
					color: ['#FCB01F', '#29C097'],
					title: {
						text: ''
					},
					legend: {},
					radar: [{
						indicator: list,
						center: mylist.length==3?['50%', '65%']:['50%', '50%'],
						radius: '80%', //图表占满整个div
						axisName: {
							color: '#000',
							// backgroundColor: '#666',
							// borderRadius: 3,
							// padding: [3, 5]
						}
					}],
					series: [{
						type: 'radar',
						emphasis: {
							lineStyle: {
								width: 4
							}
						},
						data: [{
								value: alllist,
								name: '全体得分率'
							},
							{
								value: mylist,
								name: '我的得分率',
								areaStyle: {
									color: 'rgba(41,192,151, 0.6)'
								}
							}
						]
					}]
				};
				myChart.setOption(option);
			},
			// 学情雷达-能力
			getpageFiveMapOne(arr) {
				var myChart = echarts.init(document.getElementById('pageFive_map_one'))
				var list = [],
					mylist = [],
					alllist = [];
				arr.forEach((item, i) => {
					if (arr.length > i + 1) {
						list.push({
							name: item.name,
							max: 100
						});
						mylist.push(item.correctprop);
						alllist.push(item.scoringrate);
					}
				})
				let option = {
					color: ['#FCB01F', '#EEC5C3'],
					title: {
						text: ''
					},
					legend: {},
					radar: [{
						indicator: list,
						center: mylist.length==3?['50%', '60%']:['50%', '50%'],
						radius: '80%', //图表占满整个div
						axisName: {
							color: '#000',
							// backgroundColor: '#666',
							// borderRadius: 3,
							// padding: [3, 5]
						}
					}],
					series: [{
						type: 'radar',
						emphasis: {
							lineStyle: {
								width: 4
							}
						},
						data: [{
								value: alllist,
								name: '全体得分率'
							},
							{
								value: mylist,
								name: '我的得分率',
								areaStyle: {
									color: 'rgba(238,197,195, 0.6)'
								}
							}
						]
					}]
				};
				myChart.setOption(option);
			},
			// 试卷分析&学习策略圆饼图
			getpageSixMapOne(arr) {
				var myChart = echarts.init(document.getElementById('pageSix_map_one'));
				var list = [];
				arr.forEach((item) => {
					list.push({
						name: item.name,
						value: item.total
					})
				})
				let option = {
					title: {
						text: '',
						subtext: '',
						left: 'center'
					},
					// tooltip: {
					//   trigger: 'item',
					//   formatter: '{a} <br/>{b} : {c} ({d}%)'
					// },
					// legend: {
					// 	bottom: 10,
					// 	left: 'center',
					// 	data: arr.map(item=>item.name)
					// },
					series: [{
						type: 'pie',
						radius: '75%',
						center: ['50%', '50%'],
						selectedMode: 'single',
						data: list,
						color: ['#C23531', '#2F4554', '#61A0A8', '#D48265', '#91C7AE', '#749F83', '#CA8622',
							'#BDA29A', '#6E7074',
							'#546570', '#C4CCD3',
						]
						// emphasis: {
						//   itemStyle: {
						//     shadowBlur: 10,
						//     shadowOffsetX: 0,
						//     shadowColor: 'rgba(0, 0, 0, 0.5)'
						//   }
						// }
					}]
				};
				myChart.setOption(option);
			},
			// 试卷分析&学习策略 薄弱点柱状图
			getpageSixMapTwo(arr) {
				var myChart = echarts.init(document.getElementById('pageSix_map_two'))
				let option = {
					title: {
						text: '薄弱知识点',
						subtext: '学习指数',
						left: 'left'
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					// legend: {
					// 	data: arr.map(item=>item.name),
					// },
					grid: {
						left: '0%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						show: true,
						type: 'value', // 设置x轴为数值轴
						boundaryGap: [0, 0.01],
						max: 100, // 设置x轴的最大值为100
						// name: '时间',

					},
					yAxis: {
						show: true,
						type: 'category',
						data: arr.map(item => item.name),

					},
					series: [{
						name: '学习指数',
						type: 'bar',
						data: arr.map(item => item.learn),
						barWidth: 25,
						itemStyle: {
							// barBorderRadius: [0, 20, 20, 0],
							color: '#00ADEF'
						},

					}]
				};
				myChart.setOption(option);
			},
			// 下载图片
			clickimgDown(el) {
				var that = this,scale = el;
				if (this.info.file && this.info.file != '' && this.info.file != null) {
					let a = document.createElement("a"); // 生成一个a元素
					let event = new MouseEvent("click"); // 创建一个单击事件
					a.target = "_blank";
					a.href = this.info.file; // 将生成的URL设置为a.href属性
					a.dispatchEvent(event); // 触发a的单击事件
				} else {
					this.onloading = true;
					this.loadtext = '报告长图生成中，请稍后...';
					if(this.info.username!=''){
						var title = this.info.username + "-" + this.info.name + "-" + this.info.createtime.replace(/-/g, '') + "-考试大师.png";
					}else{
						var title = this.info.name + "-" + this.info.createtime.replace(/-/g, '') + "-考试大师.png";
					}
					const element = this.$refs.imgcontent; // 获取需要生成图片的DOM元素
					html2Canvas(element, {
						allowTaint: true,
						taintTest: false,
						logging: false,
						useCORS: true,
						dpi: window.devicePixelRatio * 2,
						scale: scale // 按比例增加分辨率
					}).then((canvas) => {
						const blob = that.dataURLtoBlob(canvas.toDataURL('image/png'));
						// 使用axios发送POST请求
						const formData = new FormData();
						formData.append('file', blob, 'image.png');
						formData.append('name', title);
						if(this.$utile.locatFun('token')){
							that.$api.FILE(that.$face.uploadApi, formData, function(res) {
								that.$api.POST(that.$face.upReportApi, {
									id: that.info.id,
									file: res.data.fullurl
								}, function() {
									that.$set(that.info, 'file', res.data.fullurl);
								})
								let a = document.createElement("a"); // 生成一个a元素
								let event = new MouseEvent("click"); // 创建一个单击事件
								a.download = title; // 设置图片名称没有设置则为默认
								a.href = res.data.fullurl; // 将生成的URL设置为a.href属性
								a.dispatchEvent(event); // 触发a的单击事件   
								that.onloading = false;
							})
						}else{
							var img = new Image();
							img.src = canvas.toDataURL("image/png");
							let a = document.createElement("a"); // 生成一个a元素
							let event = new MouseEvent("click"); // 创建一个单击事件
							a.download = title; // 设置图片名称没有设置则为默认
							a.href = img.src; // 将生成的URL设置为a.href属性
							a.dispatchEvent(event); // 触发a的单击事件   
							that.onloading = false;
						}
					}).catch((cavas) => {
						that.$utile.confirm('生成的长图内容过多，高分辨率下生成文件过大，浏览器生成失败，需要降低长图分辨率，请确定是否降低分辨率生成!', function() {
							that.clickimgDown(scale-0.2);
						},1);
						that.onloading = false;
					});
				}
			},
			// 将Base64字符串转换为Blob对象
			dataURLtoBlob(dataurl) {
				let arr = dataurl.split(',');
				let mime = arr[0].match(/:(.*?);/)[1];
				let bstr = atob(arr[1]);
				let n = bstr.length;
				let u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new Blob([u8arr], {
					type: mime
				});
			},
			// 导出PDF报告
			exportPDF() {
				var that = this;
				if (this.info.file && this.info.file != '' && this.info.file != null) {
					var a = document.createElement('a');
					a.href = this.info.file;
					a.target = "_blank";
					a.style.display = 'none';
					// 将<a>元素添加到页面上
					document.body.appendChild(a);
					// 触发点击事件，开始下载
					a.click();
					// 下载完成后，移除<a>元素
					document.body.removeChild(a);
				} else {
					this.onloading = true;
					this.loadtext = 'pdf报告生成中，请稍后...';
					const fileList = document.getElementsByClassName('htmlpdf') // 很重要
					var title = that.info.name + '-' + that.info.username + '-' + that.info.id + '.pdf';
					htmlPdf(title, document.querySelector('#pdfContent'), fileList, '', function(res) {
						const uint8ArrayPdf = res.output("arraybuffer");
						const formData = new FormData();
						formData.append('file', new Blob([uint8ArrayPdf], {
							type: 'application/pdf'
						}), 'upload.pdf');
						formData.append('name', title);
						console.log('打印fullurl', res.data.fullurl)
						that.$api.FILE(that.$face.uploadApi, formData, function(res) {
							that.$api.POST(that.$face.upReportApi, {
								id: that.info.id,
								file: res.data.fullurl
							}, function() {})
							that.onloading = false;
							var a = document.createElement('a');
							a.href = res.data.fullurl;
							a.target = "_blank";
							a.download = that.info.name + '.pdf'; // 可以自定义下载文件的名称
							a.style.display = 'none';
							// 将<a>元素添加到页面上
							document.body.appendChild(a);
							// 触发点击事件，开始下载
							a.click();
							// 下载完成后，移除<a>元素
							document.body.removeChild(a);
						})
					})
				}
			}
		}
	}
</script>

<style scoped>
	.details {
		background-color: rgba(246, 246, 246, 1);
		padding: 0px 0px 60px;
		margin: 0;
	}

	/* 全局宽度 */
	.main {
		width: 1200px;
		height: 100%;
		margin: 0 auto;
	}

	.evaluationReport {
		width: 100%;
		height: auto;
		background: rgba(255, 255, 255, 1);
		box-sizing: border-box;
		padding: 30px;
	}
	/* 封面 */
	.pageZero {
		width: 100%;
		min-height: 100vh;
		height: auto;
		padding: 50px;
		box-sizing: border-box;
	}

	.pageZero .one {
		width: 100%;
		box-sizing: border-box;
		padding: 0 50px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 80px;
	}

	.pageZero .one img {
		width: 200px;
	}

	.pageZero .one .oneline {
		width: 70%;
		height: 10px;
		background-color: #073190;
	}

	.pageZero .two {
		margin: auto;
		width: 78%;
		display: flex;
	}

	.pageZero .three {
		text-align: center;
		font-size: 32px;
		margin-top: 10px;
		color: #000000;
	}

	.pageZero .four {
		width: 595px;
		display: flex;
		margin: 0px auto;
	}

	.pageZero .five {
		text-align: center;
		font-size: 34px;
		color: #000000;
		margin-top: -80px;
		position: relative;
		z-index: 99;
	}

	.pageZero .linebox {
		margin: 30px 0 90px;
	}

	.pageZero .linebox div {
		width: 100%;
		height: 48px;
		background-color: #073190;
	}


	.pageZero .linebox .lines {
		margin-top: 10px;
		height: 10px;
	}


	.pageZero .sex {
		display: flex;
		justify-content: space-between;
		width: 100%;
		box-sizing: border-box;
		padding: 0 13%;
	}

	.pageZero .sex .sex_left {
		font-size: 20px;
	}

	.pageZero .sex .sex_left .item {
		display: flex;
		height: 44px;
	}

	.pageZero .sex .sex_left .item div {
		width: 86px;
		text-align: justify;
		text-justify: inter-word;
	}

	.pageZero .sex .sex_left .item div:after {
		content: '';
		display: inline-block;
		width: 100%;
	}


	.pageZero .sex .sex_right {
		display: flex;
	}

	.pageZero .sex .sex_right div {
		writing-mode: vertical-rl;
		letter-spacing: 1px;
		margin-right: 10px;
	}

	.pageZero .sex .sex_right img {
		width: 100px;
		height: 100px;
	}



	.page {
		width: 100%;
		box-sizing: border-box;
		padding: 50px 120px;
		height: auto;
	}

	.page .title {
		text-align: center;
		font-size: 34px;
	}

	.page .title_two {
		text-align: center;
		font-size: 28px;
		margin: 20px 0;
	}

	.page .title_border {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 20px;
	}

	.page .title_border div {
		font-size: 34px;
		border-bottom: 5px solid #FF0000;
		width: auto;
		display: inline-block;
	}


	.page.titles {
		text-align: center;
		font-size: 18px;
		margin-bottom: 20px;
	}

	.page .infos {
		width: 56%;
		margin: auto;
		font-size: 20px;
		line-height: 32px;
		margin-bottom: 10px;
	}

	.page .infos .top {
		font-weight: bold;
	}

	.page .infos .red {
		color: #FF0000;
	}


	/* 第二页 */

	.pageTwo .labelbox {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.pageTwo .labelbox .label {
		width: 31%;
	}

	.pageTwo .labelbox .label div:first-child {
		width: auto;
		border: 1px solid #E0E0E0;
		display: inline-block;
		padding: 3px 6px;
	}

	.pageTwo .originalScore .num {
		width: 100%;
		box-sizing: border-box;
		padding-left: 60px;
		font-size: 24px;
	}

	.pageTwo .originalScore .tips {
		font-size: 14px;
		text-align: right;
		margin-top: 5px;
	}

	.pageTwo .originalScore table {
		width: 100%;
		box-sizing: border-box;
		text-align: center;
		font-size: 16px;
	}

	.pageTwo .originalScore table thead {
		background: #ADD8E6;
		font-weight: bold;
	}

	.pageTwo .originalScore table tbody tr td:first-child {
		font-weight: bold;
	}

	.pageTwo .originalScore table td {
		height: 40px;
	}


	.pageTwo .originalScore table,
	.pageTwo .originalScore th,
	.pageTwo .originalScore td {
		border: 1px solid black;
		border-collapse: collapse;
		/* 移除单元格之间的间隔 */
	}


	.pageTwo .yuce {
		border: 1px solid #000;
		width: 100%;
		box-sizing: border-box;
		border-radius: 10px;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		padding: 50px 80px 35px;
	}
	.pageTwo .yuce .item {
		width: 100%;
		color: #fff;
	}

	.pageTwo .yuce .item_tit {
		display: inline-block;
		padding: 4px 10px;
	}

	.pageTwo .yuce .item_info {
		font-size: 16px;
		margin-bottom: 15px;
		padding: 2px 4px;
		box-sizing: border-box;
	}
	.pageTwo .yuce .item .item_tit,
	.pageTwo .yuce .item .item_info {
		background-color: #73309A;
	}
	.pageTwo .yuce .item:nth-child(2) .item_tit,
	.pageTwo .yuce .item:nth-child(2) .item_info {
		background-color: #FB0300;
	}
	.pageTwo .yuce .item:nth-child(3) .item_tit,
	.pageTwo .yuce .item:nth-child(3) .item_info {
		background-color: #000000;
	}
	.pageTwo .yuce .item:nth-child(4) .item_tit,
	.pageTwo .yuce .item:nth-child(4) .item_info {
		background-color: #07AE4D;
	}


	.pageTwo .right {
		width: 100%;
		margin: 80px 0px 40px;
	}

	.pageTwo .right .right_tit {
		text-align: center;
		font-size: 24px;
		margin-bottom: 20px;
		display: flex;
		align-items: baseline;
		justify-content: center;
	}

	.pageTwo .right .right_tit div {
		font-size: 46px !important;
		color: #FF0000;
	}


	.pageTwo .right .right_info {
		font-size: 20px;
		line-height: 26px;
	}



	/* 第三页 */
	.pageThree p {
		line-height: 26px;
	}

	.pageThree table {
		width: 100%;
		box-sizing: border-box;
		text-align: center;
		font-size: 16px;
		border: 1px solid black;
		border-collapse: collapse;
		/* 移除单元格之间的间隔 */
	}

	.pageThree table tr:first-child td,
	.pageThree table tr:nth-child(2) td {
		background: #ADD8E6;
	}

	.pageThree table tr:first-child td:first-child {
		width: 45%;
	}

	.pageThree table td {
		height: 40px;
	}

	.pageThree table .chang {
		color: #8DD98D;
	}

	.pageThree table .duan {
		color: #FCB01F;
	}

	.pageThree table {
		border-top: 1px solid black;
		border-left: 1px solid black;
		border-collapse: collapse;
	}

	.pageThree td {
		border-right: 1px solid black;
		border-bottom: 1px solid black;
		border-collapse: collapse;
	}
	.pageSix .infos {
		width: 72%;
		margin-bottom: 20px;
	}
	.pageSeven {
		width: 100%;
		box-sizing: border-box;
		padding: 60px;
	}
	.pagenopadd{
		padding: 0px!important;
	}
	.programmesty{
		width: calc(100% - 30px);
		padding: 0px 15px;
		height: auto;
	}
	.pageSeven .xxjy {
		font-size: 34px;
		text-align: center;
		margin: 10px 0px 30px;
	}
	.pageSeven .pageSevenCon {
		width: 100%;
		box-sizing: border-box;
		min-height: 80vh;
		height: auto;
		border: 10px solid #FF3300;
		padding: 50px 30px;
		padding-bottom: 300px;
		position: relative;
		/* 设置背景图 */
		background-size: auto;
	}


	.pageSeven .pageSevenCon .title {
		color: #FF0000;
		font-weight: bold;
		font-size: 60px;
		margin: 30px 0 40px;
	}

	.pageSeven .pageSevenCon .con {
		white-space: pre-line;
		line-height: 36px;
		font-size: 22px;

	}

	.pageSeven .pageSevenCon .con span {
		color: #ff3300;
	}
	@keyframes scaleAnimation {
		0% {
			transform: scale(1);
		}
		50% {
			transform: scale(1.1); /* 放大10% */
		}
		100% {
			transform: scale(1);
		}
	}

	.pageSeven .pageSevenCon .bot {
		position: absolute;
		bottom: 80px;
		left: 30px;
		display: flex;
		align-items: end;
		width: 80%;
		box-sizing: border-box;
		justify-content: space-between;

	}

	.pageSeven .pageSevenCon .bot .lefimg {
		width: 399px;
		height: auto;
	}

	.pageSeven .pageSevenCon .bot .name {
		margin-top: -20px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.pageSeven .pageSevenCon .bot .name div {
		font-size: 12px;
	}

	.pageSeven .pageSevenCon .bot .bot_rig {
		display: flex;
		align-items: flex-start;
	}

	.pageSeven .pageSevenCon .bot .bot_rig img {
		height: 40px;
	}


	.pageEight {
		width: 100%;
		box-sizing: border-box;
		padding: 60px;
	}

	.pageEight .pageEightCon {
		width: 100%;
		box-sizing: border-box;
		min-height: 92vh;
		height: auto;
		border: 10px solid #FF3300;
		padding: 50px 30px;
		padding-top: 80px;
	}

	.pageEight .pageEightCon table {
		width: 100%;
		box-sizing: border-box;
		text-align: center;
		font-size: 16px;
		margin-top: 80px;
	}

	.pageEight .pageEightCon table thead {
		background: #ADD8E6;
		font-weight: bold;
	}

	.pageEight .pageEightCon table tbody tr td:first-child {
		font-weight: bold;
	}

	.pageEight .pageEightCon table td {
		height: 40px;
	}

	.pageEight .pageEightCon table tr td:first-child {
		width: 40%;
	}

	.pageEight .pageEightCon table,
	.pageEight .pageEightCon th,
	.pageEight .pageEightCon td {
		border: 1px solid black;
		border-collapse: collapse;
		/* 移除单元格之间的间隔 */
	}
	.pageNine {
		width: 100%;
		box-sizing: border-box;
		padding: 60px;
	}
	.pageNine .pageEightCon {
		width: 100%;
		box-sizing: border-box;
		min-height: 92vh;
		height: auto;
		/* padding: 30px 0px 0px;
		margin-top: 20px; */
	}

	.pageNine .pageEightCon .title_border span {
		color: #FF3300;
		font-size: 15px;
		font-weight: bold;
	}

	.pageNine .pageEightCon .tips {
		text-align: center;
		margin-bottom: 30px;
	}

	.pageNine .pageEightCon .itembox {
		width: 100%;
		box-sizing: border-box;
	}

	.pageNine .pageEightCon .itembox .item {
		margin-bottom: 10px;
	}


	.pageNine .pageEightCon .itembox table {
		width: 100%;
		box-sizing: border-box;
		text-align: center;
		font-size: 16px;
		margin: 10px 0;
	}

	.pageNine .pageEightCon .itembox table td {
		height: 40px;
		overflow: hidden;
		/* 隐藏溢出内容 */
		text-overflow: ellipsis;
		/* 溢出时显示省略号（可选） */
		white-space: normal;
		/* 允许换行 */
	}

	.pageNine .pageEightCon .itembox table td img {
		width: 22px;
		display: inline-block;
		margin-left: 8px;
	}

	.pageNine .pageEightCon .itembox table,
	.pageNine .pageEightCon .itembox th,
	.pageNine .pageEightCon .itembox td {
		border: 1px solid black;
		border-collapse: collapse;
		/* 移除单元格之间的间隔 */
	}



	.pageNine .pageEightCon .itembox .item .item_top {
		display: flex;
		align-items: center;
		font-size: 26px;
		color: #fff;
	}

	.pageNine .pageEightCon .itembox .item .item_top .num {
		background-color: #4473C5;
		border-radius: 50%;
		width: 50px;
		height: 50px;

		display: flex;
		align-items: center;
		justify-content: center;
	}
	.pageNine .pageEightCon .itembox .item .item_top .topic {
		font-size: 22px;
		background-color: #4473C5;
		border-radius: 30px;
		padding: 11px 20px;
	}


	.pageNine {
		width: 100%;
		box-sizing: border-box;
		padding: 60px;
	}

	.pageNine .oneTable table tr td {
		padding: 10px 0;
		white-space: normal;
	}

	.pageNine .oneTable table tr td:first-child {
		width: 38.5%;
	}

	.pageNine .oneTable table tr td:nth-child(2) {
		width: 21.8%;
	}

	.pageNine .oneTable table tr td:nth-child(3) {
		width: 17.5%;
	}

	.pageNine .oneTable table tr td:nth-child(4) {
		width: 9%;
	}

	.pageNine .oneTable table tr td:nth-child(5) {
		width: 13.5%;
	}

	.pageNine .twoTable table tr td {
		padding: 10px 0;
		white-space: normal;
	}

	.pageNine .twoTable table tr td:first-child {
		width: 40%;
	}

	.pageNine .twoTable table tr td:nth-child(2) {
		width: 20%;
	}

	.pageNine .twoTable table tr td:nth-child(3) {
		width: 9.1%;
	}

	.pageNine .twoTable table tr td:nth-child(4) {
		width: 15%;
	}

	.pageNine .twoTable table tr td:nth-child(5) {
		width: 15%;
	}


	.pageTen {
		width: 100%;
		box-sizing: border-box;
		padding: 60px;
		background-size: 100% auto;
		background-position: top center;
	}
	.pageTen .quest_read {
		text-align: justify;
		text-indent: 2em;
	}
	.pageTen .pageEightCon {
		width: 100%;
		box-sizing: border-box;
		min-height: 94vh;
		height: auto;
	}

	.pageTen .pageEightCon .itembox {
		padding-top: 40px;
		page-break-inside: avoid;
	}

	.pageTen .pageEightCon .topic {
		font-size: 16px;
		font-weight: 500;
		letter-spacing: 0px;
		color: rgba(0, 0, 0, 1);
		margin: 10px 0 20px;
	}

	.pageTen .pageEightCon .item {
		width: 100%;
		opacity: 1;
		border-radius: 10px;
		box-sizing: border-box;
		margin-bottom: 10px;
		padding: 10px 15px;
		display: flex !important;
		align-items: center;
	}

	.pageTen .pageEightCon .item .option_num {
		width: 30px;
		height: 30px;
		opacity: 1;
		background: rgba(255, 255, 255, 1);
		border: 1px solid rgba(229, 229, 229, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		font-weight: 500;
		letter-spacing: 0px;
		color: rgba(51, 51, 51, 1);
		border-radius: 50%;
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
	}

	.pageTen .pageEightCon .item .option_con {
		margin-left: 20px;
		width: 700px;
		font-size: 16px;
		font-weight: 400;
		letter-spacing: 0px;
		color: rgba(51, 51, 51, 1);
	}

	.pageEleven {
		width: 100%;
		box-sizing: border-box;
		padding: 60px 60px 160px;
		background-repeat: no-repeat, repeat-y;
		background-size: 100% auto, 100% auto;
		background-position: left bottom, center center;
	}

	.pageEleven .pageEightCon {
		width: 100%;
		height: auto;
		min-height: 88vh;
		box-sizing: border-box;
	}

	.pageEleven .pageEightCon .itembox {
		padding-top: 40px;
		page-break-inside: avoid;
	}

	.pageEleven .pageEightCon .titlesty {
		font-size: 16px;
		font-weight: bold;
	}

	.pageEleven .pageEightCon .topic {
		font-size: 16px;
		font-weight: 500;
		letter-spacing: 0px;
		color: rgba(0, 0, 0, 1);
		margin: 10px 0px 0px;
	}

	.pageEleven .pageEightCon .topic span {
		font-size: 16px;
		font-weight: 500;
		line-height: 25px;
		color: rgba(0, 0, 0, 1);
	}

	.downBtnparsty {
		position: fixed;
		left: 50%;
		bottom: 0px;
		width: 1200px;
		height: 60px;
		padding-top: 20px;
		text-align: center;
		margin-left: -600px;
		background-color: #ffffff;
		z-index: 100;
		box-shadow: 0px -2px 0px 0px rgba(0, 0, 0, 0.1);
	}

	.downBtn,.downBtnsing{
		display: inline-block;
		opacity: 1;
		width: 165px;
		height: 40px;
		line-height: 37px;
		border-radius: 5px;
		text-align: center;
		padding: 0 8px;
		cursor: pointer;
		font-weight: bold;
		margin: 0px 30px;
		background: rgba(7, 49, 144, 0);
		border: 2px solid rgba(62, 136, 254, 1) !important;
		color: rgba(62, 136, 254, 1) !important;
	}
	.downBtnparsty .downBtnsing{
		width: 240px;
	}

	.right_tit,
	.yuce .left,
	.yuce,
	.pageSeven .bot,
	.pageSeven .bot .bot_rig .name,
	.pageEightCon .itembox .item,
	.pageEightCon .itembox .item .option_num,
	.sex .sex_left .item {
		display: flex;
	}

	.pageEightCon table {
		width: 100% !important;
	}

	.sex .sex_left .item div {
		width: 86px;
		text-align: justify;
		text-justify: inter-word;
	}

	.levelparsty {
		color: #ea4025 !important;
	}

	@media screen and (max-width: 1000px) {
		.maskingout>>>.popopsizesty{
			zoom: 2.4;
		}
	}
	@media screen and (max-width: 860px) {
		.maskingout>>>.popopsizesty{
			zoom: 1.6;
		}
		.details{
			background-color: #ffffff;
			padding-bottom: 160px!important;
		}
		.downBtnparsty {
			width: 100%!important;
			padding: 0px!important;
			height: 160px!important;
			display: flex!important;
			align-items: center!important;
			justify-content: center!important;
		}
		.downBtnparsty .downBtn,.downBtnparsty .downBtnsing{
			transform: scale(2.6);
			-o-transform: scale(2.6);
			-ms-transform: scale(2.6);
			-moz-transform: scale(2.6);
			-webkit-transform: scale(2.6);
		}
		.downBtnparsty .downBtn:first-child{
			margin-right: 300px;
		}

	}
	@media screen and (max-width: 500px) {
		.maskingout>>>.popopsizesty{
			zoom: 2.4;
		}
	}
	/* 打印的样式 */
	@media print {

		.downBtnparsty{
			display: none;
		}

		.pageZero,
		.pageTwo,
		.pageThree,
		.pageSix,
		.pageSeven {
			display: block;
			page-break-after: always;
			/* 确保单独在一页 */
		}

		.pageten .itembox,
		.pageEleven .itembox {
			padding-top: 60px;
		}

		body {
			margin: 0 !important;
			/* 清除默认边距 */
			padding: 0 !important;
			/* 清除默认内边距 */
			margin: auto !important;
			-webkit-print-color-adjust:exact;
			-moz-print-color-adjust:exact;
			-ms-print-color-adjust:exact;
			print-color-adjust:exact;
		}

		/* 其他需要居中的元素 */
		.details {
			background-color: #fff;
			width: 100% !important;
			padding: 0 !important;
			margin: 0 auto !important;
			box-sizing: border-box;

		}

		.pageNine .pageEightCon {
			margin-top: 50px;
		}

		.evaluationReport {
			width: 100% !important;
			/* background-color: orange; */
			margin: 0 auto !important;
			display: block;
			padding: 0 !important;
			box-sizing: border-box !important;
		}

		.page {
			-webkit-print-color-adjust:exact;
			-moz-print-color-adjust:exact;
			-ms-print-color-adjust:exact;
			print-color-adjust:exact;
			padding-top: 20px !important;
			padding-bottom: 20px !important;
		}

		.pageEleven {
			padding-bottom: 160px !important;
		}
		.programmesty{
			display: block!important;
			height: 1550px!important;
			page-break-after: always!important;
			-webkit-page-break-after: always!important;
			-moz-page-break-after: always!important;
			-ms-page-break-after: always!important;
			-o-page-break-after: always!important;
		}
		.pageTwo .yuce {
			border: none!important;
			padding: 0px!important;
		}
		.pageTwo .yuce .item {
			width: 100%;
			padding: 0px 80px;
			border-left: 1px solid #000000!important;
			border-right: 1px solid #000000!important;
		}
		.pageTwo .yuce .itemonesty{
			clear: both!important;
			display: block!important;
			border: 1px solid #000000!important;
			padding: 20px 80px!important;
			margin-bottom: 160px!important;
			page-break-after: always!important;
			-webkit-page-break-after: always!important;
			-moz-page-break-after: always!important;
			-ms-page-break-after: always!important;
			-o-page-break-after: always!important;
		}
		.pageTwo .yuce .item:nth-child(2){
			padding-top: 50px!important;
			border-top: 1px solid #000000!important;
		}
		.pageTwo .yuce .item:nth-child(4){
			padding-bottom: 35px!important;
			border-bottom: 1px solid #000000!important;	
		}
		/*去除页眉页脚*/
		@page {
			size: auto;
			margin: 30px 0px 30px !important;
			padding: 0 !important;
			/* 去掉顶部标题 */
			size: portrait !important;
			/* 设置页面方向为纵向 */

		}
	}
</style>
<style>
	.el-loading-mask {
		position: fixed !important;
		width: 100% !important;
		height: 100% !important;
	}
	@media screen and (max-width: 800px){
		.el-loading-mask .el-loading-spinner{
			transform: scale(3);
		}
	}
</style>